module.exports = __webpack_public_path__ + "img/fullscreen-exit.cf8718f4.svg";